import { Button, Loading, Modal, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { driverProfileApi } from "@/redux/apis";
import { useUpdateFleetStatusMutation } from "@/redux/apis/driver/driverApi";
import { useAppDispatch } from "@/redux/hooks";
import { addToast } from "@/utils";
import { useProfileContext } from "../context";

interface UnsuspendDriverModalProps {
  open: boolean;
  onClose: () => void;
}

export const UnsuspendDriverModal = ({ open, onClose }: UnsuspendDriverModalProps) => {
  const dispatch = useAppDispatch();
  const { driver } = useProfileContext();
  const driverName = `${driver.personal.firstName} ${driver.personal.lastName}`;
  const [updateFleetStatus, { isLoading }] = useUpdateFleetStatusMutation();

  const updateStatus = () => {
    updateFleetStatus({ id: driver.uuid, account_status: "active" })
      .unwrap()
      .then(() => {
        dispatch(driverProfileApi.util.invalidateTags(["DriverProfile"]));
        addToast("success", "Successfully unsuspended driver.");
        onClose();
      })
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  };

  return (
    <Modal open={open} onClose={() => (isLoading ? null : onClose())} className="w-[80vw] !p-5 md:w-[514px] lg:w-[514px]">
      {isLoading && <Loading />}
      <Typography variant="title">Confirm Unsuspend Driver</Typography>
      <Typography variant="paragraph" className="mt-3">
        Are you sure you want to unsuspend <span className="text-info">{driverName}</span>? This action will reverse the driver&apos;s supension.
      </Typography>
      <div className="mt-[22px] flex flex-row items-center justify-end gap-x-4">
        <Button size="md" variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button size="md" variant="primary" className="border-danger bg-danger hover:bg-danger-dark" onClick={updateStatus}>
          Unsuspend Driver
        </Button>
      </div>
    </Modal>
  );
};
